import NewsModal from './news-modal';
export default NewsModal;